import { render, staticRenderFns } from "./CdkView.vue?vue&type=template&id=c0b91a00"
import script from "./CdkView.vue?vue&type=script&lang=js"
export * from "./CdkView.vue?vue&type=script&lang=js"
import style0 from "./CdkView.vue?vue&type=style&index=0&id=c0b91a00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports